import { useQuery } from "@tanstack/react-query";
import { getAllEmployees } from "../../api/apiEmployees";
import i18next from "i18next";

export function useGetEmployees(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["employees", page, perPage, filters, i18next.language],
        queryFn: () => getAllEmployees(page, perPage, filters),
        retry: false,
    });
    const employees = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
    return { isLoading, error, employees, meta };
}
